import React, { FC, ReactNode, useState } from 'react'
import styled, { css } from 'styled-components'
import { backgroundColor } from 'uiComponents/constants/colors'
import {
  fontWeightBoldRaw,
  fontWeightMediumBoldRaw,
  fwMediumBold,
} from 'uiComponents/constants/typography'
import Icon from '../Icon/Icon'
import { IconName } from '../Icon/IconName'
import { HeadingS, HeadingXS } from '../Text/Headings'

const Details = styled.div`
  background-color: ${backgroundColor};
  border-radius: 3px;
`
const Summary = styled.div`
  padding: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`
const Row = styled.div`
  display: flex;
  align-items: center;
`

const SummaryHeadline = styled(HeadingS)<{ isExpanded?: boolean }>`
  margin: 0;
  font-weight: ${({ isExpanded }) =>
    isExpanded ? fontWeightBoldRaw : fontWeightMediumBoldRaw};
`
const SummarySquareAvatar = styled.img`
  flex-shrink: 0;
  margin-right: 16px;
  width: 60px;
  height: 60px;
  background-color: white;
`
const Detail = styled(HeadingXS)`
  padding-left: 76px;
  padding-right: 66px;
  padding-bottom: 30px;
  line-height: 1.43;
  ${fwMediumBold};
`

const StyledIcon = styled(Icon)<{ active: boolean }>`
  margin-left: 15px;
  font-size: 12px;
  transition: transform 200ms ease-in;

  ${({ active }) =>
    active &&
    css`
      transform: rotate(180deg);
    `};
`

interface Props {
  className?: string
  squareImgSrc?: string
  squareImgAlt?: string
  headline: ReactNode
  description: ReactNode
}

const AccordionSection: FC<Props> = ({
  className,
  squareImgSrc,
  squareImgAlt,
  headline,
  description,
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false)

  return (
    <Details className={className}>
      <Summary
        onClick={() => {
          setIsExpanded(!isExpanded)
        }}
      >
        <Row>
          {squareImgSrc && (
            <SummarySquareAvatar
              data-testid="AccordionSquareAvatar"
              src={squareImgSrc}
              alt={squareImgAlt}
            />
          )}
          <SummaryHeadline
            data-testid="AccordionHeadline"
            isExpanded={isExpanded}
          >
            {headline}
          </SummaryHeadline>
        </Row>
        <StyledIcon
          asset={
            isExpanded ? IconName.IcChevronDown : IconName.IcChevronDownDarkGray
          }
          active={isExpanded}
        />
      </Summary>
      {isExpanded && <Detail data-testid="AccordionText">{description}</Detail>}
    </Details>
  )
}

export default AccordionSection
